<template>
    <v-combobox
        ref="searchDoctor"
        v-model.trim="doctor"
        hint="Surname, First Name"
        clearable
        :items="items"
        item-text="doc_name"
        return-object
        :placeholder="`Search Doctors from ${data.from.hosp.hosp_name}`"
        :rules="rules"
        :prepend-inner-icon="mdiMagnify"
        prefix="DR."
        :search-input.sync="searchInput"
        autocomplete="nope"
        color="teal accent-4"
        label="Full name of doctor"
    >
        <template #item="{ item }">
            <v-list class="custom-menu">
                <v-list-item style="width: 100%;">
                    <v-list-item-content>
                        <v-list-item-title style="color: black;">
                            DR. {{ item.doc_name }}
                        </v-list-item-title>
                        <v-list-item-subtitle style="font-size: 12px;">
                            {{ getDoctorSpecializations(item) }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
        <template #no-data>
            <p class="custom-menu-no-data">
                <span style="display: block;">No data available.</span>
                <span style="color: green; font-weight: 600;">If the accredited doctor is not on the list, please call HMI.</span>
            </p>
        </template>
    </v-combobox>
</template>

<script>
import { mdiMagnify } from '@mdi/js'
import { mapGetters } from 'vuex'

export default {
    props: ['data', 'triggerResetDoctor'],
    data: ()=>({
        mdiMagnify,
        searchInput: null,
        items: [],
        doctor: null,
        rules: [v=>!!v||'Full name of doctor is required.']
    }),
    computed: {
        ...mapGetters(['providerAffiDoctors'])
    },
    watch: {
        doctor(newVal) {
            if (typeof newVal === 'object') {
                this.$emit('saveNewDoctor', newVal)
            } else {
                let isDoctorExists = true
                if (this.providerAffiDoctors && this.providerAffiDoctors.data)
                    isDoctorExists = this.providerAffiDoctors.data.some(item => item.doc_name === newVal.toUpperCase())
                // blank the text field when doctor is not exists
                if (!isDoctorExists) {
                    this.$nextTick(()=>{
                        this.searchInput = null
                        this.doctor = null
                    })
                    this.$emit('saveNewDoctor', null)
                } else {
                    const doctorData = this.providerAffiDoctors.data.filter(item => item.doc_name === newVal.toUpperCase())
                    this.$nextTick(()=>{
                        this.searchInput = doctorData[0].doc_name
                    })
                    this.$emit('saveNewDoctor', doctorData)
                }
            }
            this.$nextTick(()=>{
                if (this.$refs)
                    if (this.$refs.searchDoctor)
                        this.$refs.searchDoctor.blur()
            })
        },
        'triggerResetDoctor'() {
            this.doctor = null
        },
        providerAffiDoctors(newVal) {
            if (newVal && newVal.data)
                this.items = newVal.data
        }
    },
    methods: {
        getDoctorSpecializations(doctor) {
            return [
                doctor.doc_specialization_1,
                doctor.doc_specialization_2,
                doctor.doc_specialization_3
            ]
                .filter(Boolean)
                .join(' • ')
        }
    }
}
</script>

<style scoped>
.custom-menu {
    padding: 0 10px;
    margin: 0 10px 0 -13px;
    height: auto;
    width: 100%;
}
.custom-menu-no-data {
    padding: 7px 10px;
    margin: 0 10px;
    height: auto;
    width: 100%;
}
</style>
